import React from 'react'
import GameLayout from './components/GameLayout/GameLayout'

const App: React.FC = () => {
    return (
        <div className="App">
            <GameLayout />
        </div>
    )
}

export default App
